// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1aos4","filesListContainer":"PosDisputesFiles_filesListContainer__3QY4G","filesButton":"PosDisputesFiles_filesButton__1NPoP"};